import React from 'react';
import { Wrapper } from './styles';

interface Loader {
  message?: string;
}

const Loader = ({ message }: Loader): React.ReactElement => (
  <Wrapper
    className="loader-container"
    role="progressbar"
    aria-valuetext={message}
    aria-busy="true"
    aria-live="assertive"
    aria-valuemin={0}
    aria-valuemax={100}
  >
    <div className="bars-container">
      <span className="bar" />
      <span className="bar" />
      <span className="bar" />
      <span className="bar" />
      <span className="bar" />
    </div>
    <span aria-hidden>{message}</span>
  </Wrapper>
);

export default Loader;
